import styles from "./ElementTooltipName.module.scss";
import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";

function ElementTooltipValue({ node }) {
  const _value = nodeUtils.getValue(node);

  return <div className={styles["tooltip__value"]}>{_value}</div>;
}

export default ElementTooltipValue;
